export default __webpack_public_path__ + "static/6-tips-for-shopping-while-on-holiday-52b76a69cff4465a22b481286ac73b8a.jpg";